// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__gA_Rh","left":"StickyBox_left__18Ps7","right":"StickyBox_right__1NldN"};